import Splide from '@splidejs/splide';
import resource from './resource';
import { arrowPath } from '../components/carousel';

const configs = {
  perMove: 3,
  perPage: 3,
  pagination: false,
  arrows: true,
  isNavigation: true,
  gap: 11,
  arrowPath: arrowPath,
  i18n: {
    prev: resource.msg('button.previous', 'common'),
    next: resource.msg('button.next', 'common')
  },
  breakpoints: {
    640: {
      perPage: 2,
      perMove: 1,
      gap: 7,
      padding: {
        left: 0,
        right: '20px'
      }
    },
    1024: {
      perPage: 2,
      gap: 7
    }
  }
};

const multipack = {
  mountSliders: ($sliders) => {
    $sliders.each((index, slider) => {
      const $slider = $(slider);
      const existingSplide = $slider.data('splideInstance');

      if (existingSplide) {
        existingSplide.destroy(true);
      }

      const splideInstance = new Splide(slider, configs);
      splideInstance.mount();
      $slider.data('splideInstance', splideInstance);
    });
  }
};

export default multipack;
